import React, { useEffect, useState } from "react";
import AdminTabelHeader from "../../../components/layout/header/AdminTabelHeader";
import {
  QueryClient,
  useMutation,
  useQuery,
  useQueryClient,
} from "react-query";
import { BASEURL } from "../../../../utils/BaseUrl";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import TraingleLoading from "../../../../common/Loading/TraingleLoading";
import Swal from "sweetalert2";
import ManditoryStar from "../../../templates/ManditoryStar";

const AdminScroolForm = () => {
  const [scroolData, setScroolData] = useState({
    image_url: "",
    content: "",
    previewUrl: "",
  });

  const checkSumbit = () => {
    let status = true;

    if (scroolData.content !== "" && scroolData.image_url !== "") {
      status = false;
    } else {
      status = true;
    }
    return status;
  };

  const { id } = useParams();
  const navigate = useNavigate();

  const { data,isLoading } = useQuery({
    queryKey: "getkeyFeatures",
    queryFn: () =>
      axios.get(`${BASEURL}key_features/${id}`).then((res) => {
        return res?.data;
      }),
    onSuccess: (response) => {
      setScroolData({
        previewUrl: response?.image_url,
        content: response?.content,
      });
    },
    refetchOnWindowFocus: false,
  });

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setScroolData({
          ...scroolData,
          previewUrl: reader.result,
          image_url: file,
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleTextChange = (e) => {
    setScroolData({
      ...scroolData,
      content: e.target.value,
    });
  };

  const mutation = useMutation({
    mutationFn: (values) => {
      return axios.post(`${BASEURL}key_features`, values);
    },
    onSuccess: () => {
      Swal.fire({
        title: "Scroll card Created Successfully",
        icon: "success",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button", // Add a custom class for styling
        },
      }).then(() => {
        navigate("/admin/home/scroolcard");
      });
    },
  });

  const editMutation = useMutation({
    mutationFn: (values) => {
      return axios.put(`${BASEURL}key_features/${id}`, values);
    },
    onSuccess: () => {
      Swal.fire({
        title: "Scroll card Updated Successfully",
        icon: "success",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button", // Add a custom class for styling
        },
      }).then(() => {
        navigate("/admin/home/scroolcard");
      });
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    if (scroolData.image_url?.name) {
      formData.append("image", scroolData.image_url);
    }
    formData.append("content", scroolData.content);

    mutation.mutate(formData);
  };

  const handleUpdate = (e) => {
    e.preventDefault();

    const formData = new FormData();
    if (scroolData.image_url?.name) {
      formData.append("image", scroolData.image_url);
    }
    formData.append("content", scroolData.content);
    editMutation.mutate(formData);
  };

  return (
    <div>
      {" "}
      {( (id &&  isLoading) || mutation.isLoading || editMutation.isLoading) && <TraingleLoading />}
      <AdminTabelHeader
        title={id ? "Edit Scroll Card" : "Add Scroll Card"}
        btnStatus={false}
      />
      <div className="p-4">
        <div className="grid grid-cols-1 gap-4">
          <div>
            <ManditoryStar title={"image"} />

            <div className="flex flex-col items-center justify-center p-6 bg-gray-100 rounded-lg shadow-md w-80">
              <label
                htmlFor="imageInput"
                className="cursor-pointer flex flex-col items-center justify-center w-full h-64 bg-white border-2 border-dashed border-blue-400 rounded-lg hover:bg-blue-50 transition duration-300"
              >
                {scroolData.previewUrl ? (
                  <img
                    src={scroolData.previewUrl}
                    alt="Preview"
                    className="w-full h-full object-cover rounded-md"
                  />
                ) : (
                  <div className="text-center">
                    <svg
                      className="w-10 h-10 text-blue-400 mx-auto"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 4v16m8-8H4"
                      ></path>
                    </svg>
                    <p className="text-sm text-gray-500 mt-2">
                      Click to upload image
                    </p>
                  </div>
                )}
              </label>
              <input
                type="file"
                id="imageInput"
                accept="image/*"
                className="hidden"
                onChange={(e) => handleImageChange(e)}
              />
              {scroolData.previewUrl && (
                <button
                  className="mt-4 px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition duration-300"
                  onClick={() =>
                    setScroolData({
                      ...scroolData,
                      previewUrl: "",
                      image_url: "",
                    })
                  }
                >
                  Remove Image
                </button>
              )}
            </div>
          </div>

          <div>
            <ManditoryStar title={"Content"} />

            <textarea
              value={scroolData.content}
              name="answer"
              // className={`textarea `}
              className={`textarea ${
                scroolData.content !== ""
                  ? "input-success"
                  : // : newsCardData.heading === ""
                    // ? "input-error"
                    ""
              }`}
              maxLength={500}
              onChange={(e) => handleTextChange(e)}
            />
          </div>
        </div>
        <div className="flex justify-end my-4 ">
          <button
            onClick={() => navigate(-1)}
            // disabled={checkSubmit()}
            className={"formSubmit mr-8 cursor-pointer "}
          >
            Cancel
          </button>
          <button
            onClick={id ? (e) => handleUpdate(e) : (e) => handleSubmit(e)}
            className={`formSubmit ${
              checkSumbit() ? "cursor-not-allowed " : "cursor-pointer"
            }
             `}
          >
            {id ? "Update" : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminScroolForm;
